import React, { SVGProps } from "react";

export default function SupMoon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16.1094 11.8478C16.5761 11.8334 17.0124 12.0378 17.2677 12.329C17.5103 12.6055 17.5758 12.9314 17.4008 13.2642C17.1183 13.8012 16.7744 14.3062 16.3743 14.7684C15.4299 15.8594 14.2081 16.6705 12.8404 17.1149C11.4727 17.5593 10.0106 17.6203 8.61114 17.2914C7.21164 16.9625 5.92736 16.256 4.8965 15.2475C3.86562 14.239 3.12715 12.9666 2.76085 11.567C2.39455 10.1673 2.41437 8.69364 2.81817 7.30448C3.22196 5.91534 3.99435 4.66354 5.05194 3.68349C5.49997 3.2683 5.992 2.90854 6.51738 2.60964C6.83977 2.42623 7.1617 2.48145 7.44256 2.71707C7.73882 2.9656 7.95558 3.39993 7.95428 3.87279C7.94928 5.69915 8.31196 8.18645 10.0604 9.89691C11.8096 11.6082 14.2933 11.9039 16.1094 11.8478Z"
        stroke="currentColor"
      />
    </svg>
  );
}
